import React from "react"

const Component = ({ address }) => {
  return (
    <iframe
      src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d812.225794310487!2d139.51787531346028!3d35.481939332723414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185784cb858b47%3A0xea4b7a953d512598!2z44CSMjQxLTA4MDYg56We5aWI5bed55yM5qiq5rWc5biC5pet5Yy65LiL5bed5LqV55S677yT77yQ77yS4oiS77yT!5e0!3m2!1sja!2sjp!4v1722923139864!5m2!1sja!2sjp`}
      width="100%"
      height="450"
      frameborder="0"
      style={{ border: 0, marginBottom: "-0.5rem" }}
      allowfullscreen
      loading="lazy"
      title={`Google Map: ${address}`}
    />
  )
}

export default Component
